import { ChangeDetectionStrategy, Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ChatHistoryGroup } from 'src/app/models/history.interface';

@Component({
  selector: 'globot-chat-messages-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="message scrollable">
      <div *ngFor="let group of chatGroups; trackBy: trackByGroupDate">
        <div class="date-header">
          <span class="date-text">{{ group.date }}</span>
        </div>

        <div *ngFor="let message of group.messages.slice().reverse(); trackBy: trackByIndex">
          <!-- Mensaje del usuario -->
          <div *ngIf="message.user_prompt">
            <p class="bot">{{ message.user_prompt }}</p>
            <p class="response-message" style="margin-left: 12px;">
              {{ message.name || 'Anónimo' }} | {{ message.created_at | date : 'HH:mm' }}
            </p>
          </div>

          <!-- Respuesta -->
          <div class="user_aling">
            <div
              style="display: flex; flex-direction: column; align-items: flex-end; margin-right: 15px;"
            >
              <div *ngIf="message.response" class="user">
                <div [innerHTML]="formatMessage(message.response)"></div>
                <div *ngIf="message.response_feedback !== null && message.response_feedback !== undefined" class="response-feedback">
                  <svg *ngIf="message.response_feedback === true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#FFF" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M7 10v12" />
                    <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                  </svg>
                  <svg *ngIf="message.response_feedback === false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#FFF" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 14V2" />
                    <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                  </svg>
                </div>
              </div>

              <p class="response-message" *ngIf="message.answered_by === 'USER'">
                {{ message.user_in_control?.name }} | {{ message.created_at | date : 'HH:mm' }}
              </p>
              <p class="response-message" *ngIf="message.answered_by === 'CHATBOT'">
                Chatbot | {{ message.created_at | date : 'HH:mm' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./chat-messages-list.component.scss'],
})
export class ChatMessagesListComponent {
  @Input() chatGroups: ChatHistoryGroup[] = [];

  constructor(private sanitizer: DomSanitizer) {}

  trackByGroupDate(_index: number, group: ChatHistoryGroup): string {
    return group.date;
  }

  trackByIndex(index: number): number {
    return index;
  }

  formatMessage(text: string) {
    let formattedText = text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/ - /g, '<br>- ')
      .replace(/(\d{4}-\d{2}-\d{2})/g, '<span class="highlight-date">$1</span>')
      .replace(/(\d{1,3}(?:\.\d{3})*(?:,\d+)?)/g, '<span class="highlight-number">$1</span>');

    return this.sanitizer.sanitize(SecurityContext.HTML, formattedText);
  }
}
